import React from "react";
import PropTypes from "prop-types";
import './sharedComponents.scss';
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import {ArrowBackIos, ArrowForwardIos} from "@mui/icons-material";


const Paginator = observer(props => {
    const {generalStore} = useStores();
    

    const {onPreviousClick, onNextClick, currentMin, currentMax, total} = props;
    const isBackDisabled = currentMin <= 1;
    const isNextDisabled = currentMax >= total;
    return (
        <div className='paginator-container'>
            <div className='pagination-arrows'>
                <div className='arrows-theme' onClick={() => !isBackDisabled && onPreviousClick()}>
                    <ArrowBackIos fontSize='medium' color={isBackDisabled ? 'disabled' : 'action'}/>
                </div>
                <div className='arrows-theme' onClick={() => !isNextDisabled && onNextClick()} data-testid='arrow-forward' data-disabled={isNextDisabled}>
                    <ArrowForwardIos fontSize='medium' color={isNextDisabled ? 'disabled' : 'action'}/>
                </div>
            </div>

            <div className='text'>
                <span className="number-spread"><span className='number'>{total === 0 ? 0 : currentMin}</span> - <span
                className='number'>{currentMax}</span></span> {generalStore.translate('of')} <span className='number'>{total}</span>
            </div>
        </div>
    );
});

Paginator.propTypes = {
    onPreviousClick: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired,
    currentMin: PropTypes.number.isRequired,
    currentMax: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
};

export default Paginator;
